<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.user_nick" placeholder="请输入用户名称" class="header-input" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.user_phone" placeholder="请输入手机号码" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="userNick" label="用户名称"></el-table-column>
            <el-table-column prop="userPhone" label="手机号码"></el-table-column>
            <el-table-column prop="userImage" label="用户头像">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px;" :src="scope.row.userImage" fit="cover"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="起始时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.accessStart) }}
                </template>
            </el-table-column>
            <el-table-column label="终止时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.accessEnd ? scope.row.accessEnd : parseInt(new Date().getTime() / 1000)) }}
                </template>
            </el-table-column>
            <el-table-column label="时间间隔">
                <template slot-scope="scope">
                    {{ formatInterval(scope.row.accessStart, scope.row.accessEnd) }}
                </template>
            </el-table-column>
            <el-table-column label="当前次数/当日总数">
                <template slot-scope="scope">
                    {{ (scope.row.accessFront + 1) + "/" + scope.row.accessTotal }}
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
        }
    },
    methods: {
        formatInterval: function(timeStart, timeEnd) {
            if (!timeEnd) {
                timeEnd = parseInt(new Date().getTime() / 1000);
            }
            const totalSeconds = Math.abs(timeEnd - timeStart);
            const hour = Math.floor(totalSeconds / 3600);
            const minute = Math.floor((totalSeconds % 3600) / 60);
            const second = totalSeconds % 60;
            return `${hour}时${minute}分${second}秒`;
        }
    },
    created: function () {
        this.tag = "ACCESS";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>